// Métadonnées métier du manifeste (spec anti-perte phase 1, §5.2.1). Lecture pure,
// aucune dépendance à Capacitor : `take-lifecycle.ts` (machine à états) en a besoin
// sans jamais dépendre du plugin natif, même par rebond.
import { type MeetingContext, MeetingContextSchema } from "./schema";
import type { TakeMeta } from "./take-types";

/** Métadonnées du manifeste ; `null` si absentes ou invalides (jamais bloquant, C13). */
export function parseTakeMeta(raw: string | undefined): TakeMeta | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw);
    return typeof v?.userId === "string" && typeof v?.type === "string" ? (v as TakeMeta) : null;
  } catch {
    return null;
  }
}

/**
 * Prise d'un avis vocal (`FeedbackScreen`, `kind: "feedback"`) : jamais une
 * capture. Lue sur le JSON brut, sans exiger le reste des métadonnées — une
 * prise d'avis n'est jamais prise pour une prise « sans métadonnées » (C13),
 * qui proposerait d'en faire une capture de projet (C30).
 */
export function isFeedbackMeta(raw: string | undefined): boolean {
  if (!raw) return false;
  try {
    const v = JSON.parse(raw);
    return v?.kind === "feedback";
  } catch {
    return false;
  }
}

/**
 * Contexte de rencontre des métadonnées de la prise ; `null` s'il est absent ou
 * hors schéma. Toute ligne écrite depuis une prise passe par ici : un contexte
 * hors schéma ferait refuser la capture par Zod (invisible dans les listes).
 */
export function takeMeetingContext(meta: TakeMeta): MeetingContext | null {
  const parsed = MeetingContextSchema.safeParse(meta.meetingContext);
  return parsed.success ? parsed.data : null;
}
